module.exports = __webpack_public_path__ + "img/Hand.c357af62.svg";